import { Content } from "components/partials/layout/layout";

const ThemeVersionHistory = () => {
  return (
    <Content sx={{ pb: 2, pt: 2 }}>
      Version History
    </Content>
  );
};

export default ThemeVersionHistory;
